// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"11":"component---src-templates-pdp-template-js","89":"component---src-templates-page-js","223":"commons"}[chunkId] || chunkId) + "-" + {"11":"edde004448bb8e761dec","89":"edb3bab901578b888842","223":"40f07c2805e0d6ba3aa1","577":"09f760b12d626ec041c1"}[chunkId] + ".js";
};